<script>
  import { _ } from 'svelte-i18n'
  import CookieNotice from './CookieNotice.svelte'
  import Button from '../elements/Button.svelte'
</script>

<footer>
  <ul>
    <li>
      <a href="/help/">{$_('navigation.help')}</a>
    </li>
    <li>
      <a href="/contact/">{$_('navigation.contact')}</a>
    </li>
    <li>
      <a href="/terms/">{$_('navigation.terms')}</a>
    </li>
    <li>
      <a href="/privacy/">{$_('navigation.privacy')}</a>
    </li>
    <li>
      <a href="/advertise/">{$_('navigation.advertise')}</a>
    </li>
  </ul>
  <CookieNotice/>
</footer>

<style>
  footer {
    position: relative;
    padding: 2rem 12rem;
    line-height: 4rem;
    background-color: var(--c-accent-fill);
    transition: background-color var(--transition-props);
  }
  ul li {
    display: inline-block;
    margin-right: 2rem;
  }
  ul li a {
    color: var(--c-text-on-fill);
    text-decoration: none;
  }
  ul li a:hover {
    color: var(--c-text-on-fill-hover);
  }

  @media only screen and (max-width: 1024px) {
    footer {
      padding: 2rem 4rem;
    }
  }
</style>